/**
 * Calendar Arche Page
 *
 * Route wrapper: ArcheLayout + ArcheHeader + Routes for the calendar arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { ARCHE_ID } from '../constants';
import { CalendarMainPage } from './CalendarMainPage';
import { AnalyticsPage } from './AnalyticsPage';

export function CalendarArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId={ARCHE_ID} title="Calendar" />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/*" element={<CalendarMainPage />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
